<template>
  <div id="app">
    <Header v-show="!hiddenHeaderRoute.includes($route.name)"></Header>
    <router-view />
    <el-popover
      placement="right"
      width="80"
      trigger="hover"
      class="lang-popover"
      v-model="visible"
    >
      <ul>
        <li
          v-for="item in langList"
          :key="item.name"
          @click="changeLanguage(item.name)"
        >
          {{ item.lang }}
        </li>
      </ul>
      <div slot="reference" class="lang-btn" v-show="showLangRoute.includes($route.name)">{{ textMap[language] }}</div>
      <!-- <div slot="reference" class="lang-btn">1111</div> -->
    </el-popover>
  </div>
</template>

<script>
import Header from "@/components/Header";

export default {
  name: "App",
  data() {
    return {
      hiddenHeaderRoute: ["iot", "iot-panel", "iot-devices"],
      showLangRoute: ["abbr-search"],
      language: "en",
      langList: [
        {
          name: "en",
          lang: "English",
        },
        {
          name: "cn",
          lang: "简体中文",
        },
      ],
      textMap: {
        en: "EN",
        cn: "中文",
      },
      visible: false
    };
  },
  components: {
    Header,
  },
  mounted() {
    this.language = this.$store.state.language || "en";
  },
  methods: {
    changeLanguage(lang) {
      this.language = lang;
      this.$i18n.locale = lang;
      console.log('this.$i18n.locale', this.$i18n.locale)
      this.$store.commit("SET_LANGUAGE", this.$i18n.locale);
      this.visible = false
    },
  },
};
</script>

<style>
@import "../static/reset.css";
</style>
<style lang="less">
@import "./main.less";
.lang-btn {
  background: #fff;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  box-shadow: 0px 1px 10px rgba(152, 152, 152, 0.65);
  cursor: pointer;
}
.lang-popover {
  position: fixed;
  bottom: 30px;
  right: 30px;
}
.el-popover {
  text-align: center;
  li {
    padding: 6px 0;
    cursor: pointer;
    text-align: center;

    &:hover {
      background: aliceblue;
    }
  }
}
</style>
<style>
body {
  font: 12px/1.5 tahoma, arial, "Hiragino Sans GB", \5b8b\4f53, sans-serif;
}
</style>



// WEBPACK FOOTER //
// src/App.vue